import { base64ToString, stringToBase64 } from '@/common/utils/encryption.utils';

type WebStorageStoredValue = null | string | Record<string, string | number> | (string | number)[];
const { localStorage, sessionStorage } = window;
export const LOCAL_STORAGE_KEYS = {
  BOARD_ID: 'boardId',
  USER_ID: 'userId',
  PORTAL_ROLE: 'userPortalRole',
  REFRESH_TIME: 'refreshTime',
  USER_AGREEMENT_STATE: 'userAgreementState',
  USER_NAME: 'userName',
  USER_EMAIL: 'userEmail',
  IS_USER_BOARD_SELECTED: 'isUserBoardSelected',
  ENCRYPTION_NONCE: 'encryptionNonce',
  IS_USER_LOGIN_SET: 'isUserLoginSet',
  SESSION_ACTIVITY_TIMESTAMP: 'sessionActivityTimestamp',
  ERROR_TYPE: 'errorType',
  PP_EMP_FILTER_FORM: 'ppEmpFilter',
  PP_EMP_FILTER_BOX_EXPAND_STATUS: 'ppEmpFilterBoxExpandStatus',
  PP_EMP_FILTER_RESULT: 'ppEmpFilterResult',
};

const webStorage = {
  local: {
    setItem(itemName: string, itemValue: WebStorageStoredValue) {
      const encodedItemName = stringToBase64(itemName);
      const encodedItemValue = stringToBase64(JSON.stringify(itemValue));
      localStorage.setItem(encodedItemName, encodedItemValue);
    },
    getItem(itemName: string): WebStorageStoredValue {
      const encodedItemName = stringToBase64(itemName);
      let storedValue = localStorage.getItem(encodedItemName);

      storedValue = storedValue ? JSON.parse(base64ToString(storedValue)) : null;

      return storedValue;
    },
    removeItem(itemName: string) {
      const encodedItemName = stringToBase64(itemName);
      localStorage.removeItem(encodedItemName);
    },
    removeItems(itemNames: string[]) {
      itemNames.forEach((itemName) => {
        const encodedItemName = stringToBase64(itemName);
        localStorage.removeItem(encodedItemName);
      });
    },
    clear() {
      localStorage.clear();
    },
  },
  session: {
    setItem(itemName: string, itemValue: WebStorageStoredValue) {
      const encodedItemName = stringToBase64(itemName);
      const encodedItemValue = stringToBase64(JSON.stringify(itemValue));
      sessionStorage.setItem(encodedItemName, encodedItemValue);
    },
    getItem(itemName: string): WebStorageStoredValue {
      const encodedItemName = stringToBase64(itemName);
      let storedValue = sessionStorage.getItem(encodedItemName);

      storedValue = storedValue ? JSON.parse(base64ToString(storedValue)) : null;

      return storedValue;
    },
    removeItem(itemName: string) {
      const encodedItemName = stringToBase64(itemName);
      sessionStorage.removeItem(encodedItemName);
    },
    removeItems(itemNames: string[]) {
      itemNames.forEach((itemName) => {
        const encodedItemName = stringToBase64(itemName);
        sessionStorage.removeItem(encodedItemName);
      });
    },
    clear() {
      sessionStorage.clear();
    },
  },
  getFromWebStorage(itemName: string): WebStorageStoredValue {
    let itemValue = webStorage.local.getItem(itemName);

    if (!itemValue) {
      itemValue = webStorage.session.getItem(itemName);
    }

    return itemValue;
  },
  removeFromWebStorage(itemName: string) {
    webStorage.session.removeItem(itemName);
    webStorage.local.removeItem(itemName);
  },
};

export default webStorage;
